import { useMemo } from 'react';
import { useGoal } from '../../../../hooks/useGoal';
import { AsyncComponentHookResult } from '../../../../../../Types/ComponentHookResult';

interface RetirementAssumptionsDTO {
  AdditionalSavingPerMonth: number;
  EarmarkedAssets: number;
  InflationRate: number;
  LifeExpectancy: { Name: string; Age: number }[];
  MarketDrop: {
    primary: string;
    marketDropsNumYears: number;
    marketDropsPercentage: number;
    marketDropsStartingAge: number;
  } | null;
  PostRetirementAssetAllocation: string;
  PostRetirementRateOfReturn: number;
  PostRetirementStandardDeviation: number;
  PreRetirementAssetAllocation: string;
  PreRetirementRateOfReturn: number;
  PreRetirementStandardDeviation: number;
  RetirementAge: { Name: string; Age: number }[];
  RetirementLivingExpenses: { amount: number; frequency: string };
  SocialSecurityAmount: { Name: string; Amount: number }[];
  SocialSecurityFilingAge: { Name: string; Age: number }[];
  SocialSecurityInflationRate: number;
}

export const useAssumptions = (): AsyncComponentHookResult<RetirementAssumptionsDTO> => {
  const queryResult = useGoal();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    return queryResult.data.GoalAssumptions as RetirementAssumptionsDTO;
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
